import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import cn from 'classnames';
import { useTheme } from '@rescui/ui-contexts';
import styles from './card.p.module.css.js';
var THEME_STYLES = {
  light: styles.themeLight,
  dark: styles.themeDark
};
var MODE_STYLES = {
  classic: styles.modeClassic,
  rock: styles.modeRock
};
var PADDINGS_STYLES = {
  16: styles.paddings16,
  24: styles.paddings24,
  32: styles.paddings32
};
var BORDER_RADIUS_STYLES = {
  0: styles.bordersRadius0,
  8: styles.bordersRadius8,
  16: styles.bordersRadius16,
  24: styles.bordersRadius24
};
var CARD_IMAGE_STYLES = {
  cardImageImg: styles.cardImageImg,
  cardImageDiv: styles.cardImageDiv
}; // eslint-disable-next-line complexity

var cardCn = function cardCn() {
  var _THEME_STYLES$theme, _MODE_STYLES$mode, _PADDINGS_STYLES$padd, _BORDER_RADIUS_STYLES, _cn;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isClickable = _ref.isClickable,
      theme = _ref.theme,
      mode = _ref.mode,
      paddings = _ref.paddings,
      borderRadius = _ref.borderRadius,
      hasGlowHover = _ref.hasGlowHover,
      disableBorder = _ref.disableBorder;

  var themeClass = (_THEME_STYLES$theme = THEME_STYLES[theme]) !== null && _THEME_STYLES$theme !== void 0 ? _THEME_STYLES$theme : THEME_STYLES.light;
  var modeClass = (_MODE_STYLES$mode = MODE_STYLES[mode]) !== null && _MODE_STYLES$mode !== void 0 ? _MODE_STYLES$mode : MODE_STYLES.classic;
  var paddingsClass = (_PADDINGS_STYLES$padd = PADDINGS_STYLES[paddings]) !== null && _PADDINGS_STYLES$padd !== void 0 ? _PADDINGS_STYLES$padd : PADDINGS_STYLES[24];
  var borderRadiusClass = (_BORDER_RADIUS_STYLES = BORDER_RADIUS_STYLES[borderRadius]) !== null && _BORDER_RADIUS_STYLES !== void 0 ? _BORDER_RADIUS_STYLES : BORDER_RADIUS_STYLES[8];
  var showBorderStatesClass = isClickable && (!disableBorder || !hasGlowHover);
  return cn(styles.card, themeClass, modeClass, paddingsClass, borderRadiusClass, (_cn = {}, _defineProperty(_cn, styles.cardPlain, !isClickable), _defineProperty(_cn, styles.glowHover, hasGlowHover), _defineProperty(_cn, styles.withStaticBorder, !disableBorder), _defineProperty(_cn, styles.withStatesBorder, showBorderStatesClass), _cn));
};

var cardImageCn = function cardImageCn(_ref2) {
  var _CARD_IMAGE_STYLES$ca;

  var cardImageType = _ref2.cardImageType,
      disableFixedHeight = _ref2.disableFixedHeight,
      disableFullWidth = _ref2.disableFullWidth;
  var cardImgExtraStyles = (_CARD_IMAGE_STYLES$ca = CARD_IMAGE_STYLES[cardImageType]) !== null && _CARD_IMAGE_STYLES$ca !== void 0 ? _CARD_IMAGE_STYLES$ca : CARD_IMAGE_STYLES.cardImageDiv;
  return cn(styles.cardImage, cardImgExtraStyles, !disableFixedHeight && styles.fixedImageHeight, !disableFullWidth && styles.fullImageWidth);
};

var useCardCn = function useCardCn() {
  var theme = useTheme();
  return function (cardCnOptions) {
    return cardCn(_objectSpread({
      theme: theme
    }, cardCnOptions));
  };
};

export { cardCn, cardImageCn, useCardCn };
